import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import SingleDropDown from "../SingleDropDown";
import { allQueryTypes } from "./queryTypes";

const stateConditions = ["SVQ", "SNQ", "RQ", "DQ", "KQ", "SQ", "BQ"];
const controlFieldConditions = ["XQ", "UQ", "RQ", "DQ", "KQ"];
const provinceConditions = ["XQ", "UQ"];

const _spacing = "10px";

//tested
export const handleChange = (e, setState) => {
  const name = e.target.name;
  const value = e.target.value;
  setState(prevState => ({ ...prevState, [name]: value }));
};
//tested
export const isQueryFormValid = (formState, querySelection, queryState) => {
  if (querySelection?.name === "") {
    alert("Please select a query type first.");
    return false;
  }
  let message = "";
  if (
    !formState.nletsPassword ||
    !formState.nletsOri ||
    !formState.nletsDevId ||
    !formState.nletsLogin
  ) {
    message +=
      "Your machine is not properly authorized to perform Query Returns. Please contact your agency Program Manager for assistance.\n";
  }
  if (!formState.nletsOri) {
    message += "\r\n\u2022The Sub-ORI field is required.\n";
  }
  if (!formState.nletsDevId) {
    message += "\r\n\u2022The Device ID field is required.\n";
  }
  if (!formState.nletsLogin) {
    message += "\r\n\u2022The User Name field is required.\n";
  }
  if (!formState.nletsPassword) {
    message += "\r\n\u2022The Password field is required.\n";
  }

  if (
    stateConditions.some(el => querySelection?.name?.includes(el)) &&
    !formState.destination
  ) {
    message += "The Destination State field is required.\n";
  }

  if (
    provinceConditions.some(el => querySelection?.name?.includes(el)) &&
    !formState.destination
  ) {
    message += "The Destination Province field is required.\n";
  }

  if (
    querySelection?.shortcode === "SVQ" &&
    !queryState.vin &&
    !queryState.licenseType
  ) {
    message += "License Type is required if not supplying a VIN.\n";
  }

  if (
    querySelection?.shortcode === "XQ" &&
    !queryState.vin &&
    !queryState.licensePlateNumber
  ) {
    message += "VIN or License Plate Number is required.\n";
  }

  if (message.length > 0) {
    alert(message.trim());
    return false;
  } else {
    return true;
  }
};
//tested
export const handleClose = args => {
  const { setModalOpen, setFormState, user, states } = args || null;
  if (!setModalOpen || !setFormState || !user || !states) {
    console.error("Missing required parameters in handleClose function");
    return null;
  }
  setModalOpen(false);
  setFormState({
    nletsOri: user?.officer?.deptAttribute?.nletsOri || "",
    nletsDevId: user?.officer?.deptAttribute?.nletsDevId?.toString() || "",
    nletsLogin: user?.officer?.deptAttribute?.nletsLogin || "",
    nletsPassword: user?.officer?.deptAttribute?.nletsPassword || "",
    destination: states.find(state => state?.name === "VT"),
    controlField: "",
  });
};
//tested
export const handleRunQuery = (
  e,
  handlers,
  closeArgs,
  validatorFnc,
  tokenDisabled
) => {
  e?.preventDefault();
  if (tokenDisabled) {
    alert(
      "Switch access has been blocked due to the SoftToken requirement being disabled."
    );
    return null;
  }
  const {
    formState,
    queryState,
    querySelection,
    user,
    incidentId,
    sendQueryRequest,
    setStatus,
    handleClose,
    vehicleQueryCode,
    personQueryCode,
  } = handlers || null;
  //if any of the above are null log an error
  //incidentId can be null
  if (
    !formState ||
    !queryState ||
    !querySelection ||
    !user ||
    !sendQueryRequest ||
    !setStatus ||
    !handleClose ||
    (!vehicleQueryCode && !personQueryCode)
  ) {
    console.error("Missing required parameters in handleRunQuery function");
    return null;
  }

  if (validatorFnc(formState, querySelection, queryState)) {
    let input = {
      originatorId: user?.id,
      incidentId: incidentId,
      queryKey: querySelection?.shortcode,
      ORI: formState?.nletsOri,
      DAC: formState?.nletsDevId?.toString(),
      USR: formState?.nletsLogin,
      PWD: formState?.nletsPassword,
    };
    if (stateConditions.some(el => querySelection?.shortcode?.includes(el))) {
      input.DST = formState?.destination?.name;
    }
    if (
      provinceConditions.some(el => querySelection?.shortcode?.includes(el))
    ) {
      input.DST = formState?.destination?.name;
    }
    if (
      provinceConditions.some(el => querySelection?.shortcode?.includes(el))
    ) {
      input.DST = formState?.destination?.name;
    }
    if (
      controlFieldConditions.some(el =>
        querySelection?.shortcode?.includes(el)
      ) &&
      !!formState?.controlField
    ) {
      if (formState?.controlField) input.OCF = formState?.controlField;
    }
    //SVQ will use the VIN if it's present, otherwise it will use the plate, year, and license type
    if (querySelection?.shortcode === "SVQ") {
      if (queryState?.vin) {
        input.VIN = queryState?.vin;
      } else {
        if (queryState?.licensePlateNumber)
          input.LIC = queryState?.licensePlateNumber;
        if (queryState?.year) input.LIY = queryState?.year;
        if (queryState?.licenseType?.name)
          input.LIT = queryState?.licenseType?.name?.substring(0, 2);
      }
    }
    if (querySelection?.shortcode === "SNQ") {
      if (queryState?.name) input.NAM = queryState?.name;
      if (queryState?.dob) input.DOB = queryState?.dob;
      if (queryState?.gender) input.SEX = queryState?.gender;
    }
    if (querySelection?.shortcode === "RQ") {
      if (queryState?.vin) input.VIN = queryState?.vin;
      if (queryState?.make) input.VMA = queryState?.make;
      if (queryState?.vehicleYear) input.VYR = queryState?.vehicleYear;
    }
    if (
      querySelection?.shortcode === "QDL" ||
      querySelection?.shortcode === "QVP"
    ) {
      if (queryState?.pid) input.PID = queryState?.pid;
    }
    if (querySelection?.shortcode === "DQ") {
      input.IMQ = queryState?.imq;
      if (queryState?.oln) {
        input.OLN = queryState?.oln;
      } else {
        if (queryState?.name) input.NAM = queryState?.name;
        if (queryState?.dob) input.DOB = queryState?.dob;
        if (queryState?.gender) input.SEX = queryState?.gender;
      }
    }
    if (querySelection?.shortcode === "KQ") {
      if (queryState?.oln) {
        input.OLN = queryState?.oln;
      } else {
        if (queryState?.name) input.NAM = queryState?.name;
        if (queryState?.dob) input.DOB = queryState?.dob;
        if (queryState?.gender) input.SEX = queryState?.gender;
      }
      if (queryState?.purpose) input.PUR = queryState?.purpose.value;
      if (queryState?.attention) input.ATN = queryState?.attention;
      input.IMQ = queryState?.imq;
    }

    if (querySelection?.shortcode === "UQ") {
      if (queryState?.name) input.NAM = queryState?.name;
      if (queryState?.dob) input.DOB = queryState?.dob;
      if (queryState?.gender) input.SEX = queryState?.gender;
      if (queryState?.oln) input.OLN = queryState?.oln;
      if (queryState?.reasonCode?.name)
        input.RSN = queryState?.reasonCode?.name;
      if (queryState?.propInSight?.name)
        input.PPS = queryState?.propInSight?.name;
    }
    if (querySelection?.shortcode === "XQ") {
      if (queryState?.vin) {
        input.VIN = queryState?.vin;
      } else if (queryState?.licensePlateNumber) {
        input.LIC = queryState?.licensePlateNumber;
      }
      if (queryState?.reasonCode?.name)
        input.RSN = queryState?.reasonCode?.name;
      if (queryState?.propInSight?.name)
        input.PPS = queryState?.propInSight?.name;
    }
    if (querySelection?.shortcode === "QNM") {
      if (queryState?.name) input.NAM = queryState?.name;
      if (queryState?.nameWithDob) input.SNM = queryState?.nameWithDob;
      if (queryState?.dobWithName) input.DOB = queryState?.dobWithName;
      if (queryState?.soundex) input.SDX = queryState?.soundex;
      if (queryState?.gender) input.SEX = queryState?.gender;
    }
    if (querySelection?.shortcode === "SQ") {
      if (queryState?.snowmobileRegistration)
        input.REG = queryState?.snowmobileRegistration?.toUpperCase();
      if (queryState?.vin) input.VIN = queryState?.vin?.toUpperCase();
      if (queryState?.name) input.NAM = queryState?.name;
      if (queryState?.dob) input.DOB = queryState?.dob;
    }
    if (querySelection?.shortcode === "BQ") {
      if (queryState?.boatRegistration)
        input.REG = queryState?.boatRegistration?.toUpperCase();
      if (queryState?.boatHullNumber)
        input.BHN = queryState?.boatHullNumber?.toUpperCase();
      if (queryState?.name) input.NAM = queryState?.name;
      if (queryState?.dob) input.DOB = queryState?.dob;
      if (queryState?.coastGuardNumber)
        input.CGN = queryState?.coastGuardNumber?.toUpperCase();
    }

    if (["SVQ", "RQ", "QVP", "XQ"].includes(querySelection?.shortcode)) {
      let queryEntry = "";
      if (formState?.destination?.name) {
        queryEntry =
          queryEntry + "DEST: " + formState?.destination?.name + "   ";
      }
      if (queryState?.licensePlateNumber) {
        queryEntry =
          queryEntry + "LIC:  " + queryState?.licensePlateNumber + "   ";
      }
      if (queryState?.vin) {
        queryEntry = queryEntry + "VIN:  " + queryState?.vin + "   ";
      }
      if (queryState?.licenseType?.name) {
        queryEntry =
          queryEntry + "LT:  " + queryState?.licenseType?.name + "   ";
      }

      setStatus({
        variables: {
          input: {
            originatorId: user?.id,
            officerId: user?.id,
            logCodeId: vehicleQueryCode,
            entryText: queryEntry,
            updateCallLogOnly: true,
          },
        },
      });
    }
    if (
      ["SNQ", "QDL", "DQ", "QVM", "UQ", "KQ"].includes(
        querySelection?.shortcode
      )
    ) {
      let queryEntry = "";
      if (formState?.destination?.name) {
        queryEntry =
          queryEntry + "DEST:  " + formState?.destination?.name + "   ";
      }
      if (queryState?.name) {
        queryEntry = queryEntry + "NAM:  " + queryState?.name + "   ";
      }
      if (queryState?.dob) {
        queryEntry = queryEntry + "DOB:  " + queryState?.dob + "   ";
      }
      if (queryState?.gender) {
        queryEntry = queryEntry + "GEN:  " + queryState?.gender + "   ";
      }
      if (queryState?.oln) {
        queryEntry = queryEntry + "OLN:  " + queryState?.oln + "   ";
      }
      if (queryState?.pid) {
        queryEntry = queryEntry + "PID:  " + queryState?.pid + "   ";
      }
      if (queryState?.nameWithDob) {
        queryEntry =
          queryEntry + "NAM/DOB:  " + queryState?.nameWithDob + "   ";
      }
      if (queryState?.imq) {
        queryEntry = queryEntry + "IMG:  " + queryState?.imq + "   ";
      }

      setStatus({
        variables: {
          input: {
            originatorId: user?.id,
            officerId: user?.id,
            logCodeId: personQueryCode,
            entryText: queryEntry,
            updateCallLogOnly: true,
          },
        },
      });
    }

    sendQueryRequest({
      variables: { input: input },
      context: { serializationKey: "incidentQueue" },
    });
    !!handleClose && handleClose(closeArgs);
  } else {
    return null;
  }
};

export const provinces = [
  {
    id: 1,
    fullName: "AB - Alberta",
    name: "AB",
  },
  {
    id: 2,
    fullName: "BC - British Columbia",
    name: "BC",
  },
  {
    id: 3,
    fullName: "MB - Manitoba",
    name: "MB",
  },
  {
    id: 4,
    fullName: "NB - New Brunswick",
    name: "NK",
  },
  {
    id: 5,
    fullName: "NF - Newfoundland and Labrador",
    name: "NF",
  },
  {
    id: 6,
    fullName: "NS - Nova Scotia",
    name: "NS",
  },
  {
    id: 7,
    fullName: "NT - Northwest Territories",
    name: "NT",
  },
  {
    id: 8,
    fullName: "NU - Nunavut",
    name: "NU",
  },
  {
    id: 9,
    fullName: "ON - Ontario",
    name: "ON",
  },
  {
    id: 10,
    fullName: "PE - Prince Edward Island",
    name: "PE",
  },
  {
    id: 11,
    fullName: "PQ - Quebec",
    name: "PQ",
  },
  {
    id: 12,
    fullName: "SK - Saskatchewan",
    name: "SN",
  },
  {
    id: 13,
    fullName: "YT - Yukon",
    name: "YT",
  },
];
//tested
export function variableFields(
  querySelection,
  formState,
  setFormState,
  handleChange,
  states,
  classes,
  inputLabel,
  labelWidth,
  user
) {
  let controlField = null;
  let destination = null;
  let localStates = states || [];
  if (
    (querySelection?.shortcode === "DQ" ||
      querySelection?.shortcode === "KQ") &&
    !localStates.some(state => state.name === "NL")
  ) {
    localStates.push({
      __typename: "State",
      id: "NL",
      name: "NL",
      position: localStates.length + 1,
      oriId: "1",
    });
  }
  if (
    querySelection?.shortcode !== "DQ" &&
    querySelection?.shortcode !== "KQ" &&
    localStates.some(state => state.name === "NL")
  ) {
    localStates = localStates.filter(state => state.name !== "NL");
  }

  if (
    querySelection?.shortcode === "BQ" &&
    !localStates.some(state => state.name === "CG")
  ) {
    localStates.push({
      __typename: "State",
      id: "CG",
      name: "CG",
      position: localStates.length + 1,
      oriId: "1",
    });
  }
  if (
    querySelection?.shortcode !== "BQ" &&
    localStates.some(state => state.name === "CG")
  ) {
    localStates = localStates.filter(state => state.name !== "CG");
  }

  if (stateConditions.some(el => querySelection?.name?.includes(el))) {
    destination = (
      <Autocomplete
        data-testid="destination-state-autocomplete"
        autoSelect
        autoHighlight
        selectOnFocus
        size="small"
        onChange={(e, value) =>
          setFormState(prevState => ({ ...prevState, destination: value }))
        }
        value={formState?.destination || null}
        options={localStates}
        disabled={false}
        id="destination-state"
        getOptionLabel={option => option.name}
        renderInput={params => (
          <TextField
            {...params}
            label="Destination&nbsp;State"
            variant="outlined"
          />
        )}
        style={{ marginTop: "10px", paddingRight: "10px" }}
      />
    );
  }

  if (controlFieldConditions.some(el => querySelection?.name?.includes(el))) {
    controlField = (
      <TextField
        data-testid="control-field"
        variant="outlined"
        data-cy="control-field"
        inputProps={{ "data-cy": "control-field-input" }}
        InputLabelProps={{
          shrink: true,
          "data-cy": "control-field-input-label",
        }}
        margin="dense"
        id="control-field-id"
        label="Control Field (Optional)"
        value={formState.controlField || ""}
        onChange={e => handleChange(e, setFormState)}
        name="controlField"
        style={{ width: "45%" }}
      />
    );
  }

  if (provinceConditions.some(el => querySelection?.name?.includes(el))) {
    destination = (
      <SingleDropDown
        id="destination-province-dropdown"
        handleChange={e => handleChange(e, setFormState)}
        stateName={"destination"}
        value={formState?.destination || ""}
        options={provinces}
        title={"Destination Province"}
        classStyle={classes.formControl}
        inputLabel={inputLabel}
        labelWidth={labelWidth}
        style={{ width: "45%" }}
        userRoles={user?.roleNames}
        name={"fullName"}
        disabled={false}
      />
    );
  }
  if (!destination && !controlField) {
    return null;
  }

  return (
    <>
      <p style={{ fontWeight: "bold", margin: 0 }}>Header Information</p>
      <div
        data-testid="variable-fields-container"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          // width: "100%",
          border: "1px solid black",
          padding: _spacing,
        }}
      >
        {controlField}
        {destination}
      </div>
    </>
  );
}

//tested
export const initializeQueryState = (
  querySelection,
  licenseTypes,
  setQueryState
) => {
  if (querySelection?.name === "SVQ - 28") {
    setQueryState({
      year: new Date().getFullYear().toString(),
      licenseType:
        licenseTypes?.find(type => type?.name?.startsWith("PC")) ??
        licenseTypes?.[0],
    });
  } else if (querySelection?.shortcode === "DQ") {
    setQueryState({ imq: false });
  } else {
    setQueryState({});
  }
};
//tested
export const initializeFormState = (
  user,
  states,
  setFormState,
  setExpandUserInfo
) => {
  const { nletsOri, nletsDevId, nletsLogin, nletsPassword } =
    user?.officer?.deptAttribute || null;
  const userInfoMissing =
    !nletsOri || !nletsDevId || !nletsLogin || !nletsPassword;

  setFormState({
    nletsOri: nletsOri || "",
    nletsDevId: nletsDevId?.toString() || "",
    nletsLogin: nletsLogin || "",
    nletsPassword: nletsPassword || "",
    destination: states?.find(state => state?.name === "VT"),
    controlField: "",
  });
  if (userInfoMissing) setExpandUserInfo(true);
};
//tested
export const handleMutationCompleted = (
  data,
  setPopper,
  setModalOpen = null,
  setTabIndex = false
) => {
  if (data) {
    const res = data[Object.keys(data)[0]];
    if (res.message) {
      setPopper({ open: true, content: res.message, severity: "success" });
      setModalOpen && setModalOpen(false);
      setTabIndex && setTabIndex(2);
      return;
    } else {
      const errorMessage = res.errors.join(" ");
      setPopper({ open: true, content: errorMessage, severity: "error" });
      return;
    }
  }
  return null;
};
//tested
export const getDefaultQuery = () => allQueryTypes[0];
